const ProductTag = ({ label }: { label: string }) => {
	return (
		<button className="rounded-lg bg-neutral-200 px-2 py-1 text-sm text-gray-600">{label}</button>
	);
};

export default ProductTag;
